import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { LocalizedText } from 'bernie-l10n';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkSecondaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';

import { PlaybackFilter } from '../../search/playback/playback-filter';

export interface MessagingCardOverFilteredPillsProps extends RouteComponentProps {
  analytics?: AnalyticsStore;
  searchResults?: SearchResultsStore;
}

export const MessagingCardOverFilteredPillsComponent: React.FC<MessagingCardOverFilteredPillsProps> = inject(
  'searchResults',
  'analytics'
)(
  observer(({ analytics, searchResults, history, location }) => {
    const removeAllFilters = () => {
      searchResults.clearFilters(history, location);
    };

    return (
      <>
        <UitkSpacing margin={{ block: 'six' }}>
          <div>
            <PlaybackFilter analytics={analytics} wrapPills hideRemoveAllButtonsCTA centerPills />
          </div>
        </UitkSpacing>
        {searchResults?.sortAndFilter?.pills?.length > 1 && (
          <UitkSecondaryButton
            analytics={analytics && analytics.setupTracker('overFiltered.removeAllFilters', 'Remove all filters applied', null)}
            onClick={removeAllFilters}
          >
            <LocalizedText message="hotels.searchResults.playbackFilter.removeAllFilters.linkText" />
          </UitkSecondaryButton>
        )}
      </>
    );
  })
);

export const MessagingCardOverFilteredPills = withRouter(MessagingCardOverFilteredPillsComponent);
